<template>
  <div>
    <PublicLayout>
      <header class="sub-header">
        <div class="container">
          <h1>學術研究</h1>
        </div>
      </header>
      <HeaderNav activeLink="investigate" />
      <!-- main-section -->
      <section class="main-section">
        <section class="m-sec">
          <div class="container">
            <h2 class="section-title text-primary text-center">
              學術研究～開放式創新的推動
            </h2>
            <p>
              保健食品的需求逐年增加，然而其科學依據必須明確。富地滋身為核酸營養的先驅企業，一直以來與第一線的研究機關合作，為了提供更有具體性的科學根據而不斷進行學術研究。另外，為了製造更優質的核酸製品，我們的研究不只著眼在安全性試驗，更進一步探索全新的可能性。為了發現更多價值並實現每個人每一天的「健康」及「安全‧安心」，今後我們將持續致力創造永續的未來。
            </p>
            <img
              :src="require('@/assets/public/images/kakusan/investigate.png')"
              alt="次世代FD核酸實驗室"
              class="investigate-lab-image"
            />
          </div>
        </section>
      </section>
      <!-- main-section -->
    </PublicLayout>
  </div>
</template>
<script>
import PublicLayout from "../../components/public/PublicLayout";
import HeaderNav from "../../components/public/headerNav/KakusanHeaderNav";
export default {
  name: "InvestigateScreen",
  components: {
    PublicLayout,
    HeaderNav,
  },
};
</script>
<style lang="scss" scoped>
.investigate-lab-image {
  width: 100%;
  margin: 0 auto;
  display: block;
}

@media (min-width: 768px) {
  .investigate-lab-image {
    width: auto;
    max-width: 520px;
  }
}
</style>